import React, { useEffect, useState } from 'react';

import { Link, useParams } from 'react-router-dom';

import { AgentPlatformAdminGate } from '../../../components/AgentPlatform/AgentPlatformAdminGate';

import { AgentPlatformFeatureGate } from '../../../components/AgentPlatform/AgentPlatformFeatureGate';

import { AgentPlatformPageHeader } from '../../../components/AgentPlatform/AgentPlatformPageHeader';

import { AgentPlatformPanel } from '../../../components/AgentPlatform/AgentPlatformPanel';

import { AgentPlatformShell } from '../../../components/AgentPlatform/AgentPlatformShell';

import { AgentExecutionTimeline } from '../../../components/AgentPlatform/AgentExecutionTimeline';

import { JsonTextArea } from '../../../components/AgentPlatform/JsonTextArea';

import { StatusBadge } from '../../../components/AgentPlatform/StatusBadge';

import { agentPlatformService } from '../../../services/agentPlatformService';

import type { AgentExecutionDto } from '../../../types/agentPlatform';

import { labelExecutionStatus } from '../../../utils/agentPlatformLabels';



export const AgentExecutionDetailPage: React.FC = () => {

  const { id } = useParams<{ id: string }>();

  const [execution, setExecution] = useState<AgentExecutionDto | null>(null);

  const [loading, setLoading] = useState(true);



  useEffect(() => {

    if (!id) return;

    agentPlatformService

      .getExecution(id)

      .then(setExecution)

      .finally(() => setLoading(false));

  }, [id]);



  if (loading) {

    return (

      <div className="min-h-[40vh] flex items-center justify-center text-slate-500 animate-pulse">

        Carregando execução…

      </div>

    );

  }



  if (!execution) {

    return (

      <div className="py-16 text-center">

        <p className="text-slate-600 mb-4">Execução não encontrada.</p>

        <Link to="/agent-platform/executions" className="text-red-600 hover:underline font-medium">

          Voltar

        </Link>

      </div>

    );

  }



  return (

    <AgentPlatformFeatureGate feature="platform">

      <AgentPlatformAdminGate>

        <AgentPlatformShell>

          <AgentPlatformPageHeader

            backTo="/agent-platform/executions"

            backLabel="Execuções"

            title="Detalhe da execução"

            subtitle={execution.id}

            area="operations"

          />



          <div className="grid lg:grid-cols-3 gap-6">

            <div className="lg:col-span-2">

              <AgentPlatformPanel title="Timeline de steps" noPadding>

                <div className="p-6">

                  <AgentExecutionTimeline steps={execution.steps} />

                </div>

              </AgentPlatformPanel>

            </div>



            <div className="space-y-4">

              <AgentPlatformPanel title="Resumo">

                <div className="flex items-center gap-2 mb-3">

                  <StatusBadge
                    status={execution.status}
                    label={labelExecutionStatus(execution.status)}
                    kind="execution"
                  />

                  {execution.isTestExecution && (

                    <span className="text-xs text-amber-700 font-medium">teste</span>

                  )}

                </div>

                <dl className="space-y-2 text-sm">

                  <div>

                    <dt className="text-slate-500 text-xs">Agente</dt>

                    <dd>

                      <Link

                        to={`/agent-platform/agents/${execution.agentId}`}

                        className="text-red-600 hover:underline font-mono text-xs"

                      >

                        {execution.agentId}

                      </Link>

                    </dd>

                  </div>

                  <div>

                    <dt className="text-slate-500 text-xs">Correlation ID</dt>

                    <dd className="font-mono text-xs break-all text-slate-700">{execution.correlationId}</dd>

                  </div>

                  <div>

                    <dt className="text-slate-500 text-xs">Início</dt>

                    <dd>{new Date(execution.startedAt).toLocaleString('pt-BR')}</dd>

                  </div>

                  {execution.completedAt && (

                    <div>

                      <dt className="text-slate-500 text-xs">Fim</dt>

                      <dd>{new Date(execution.completedAt).toLocaleString('pt-BR')}</dd>

                    </div>

                  )}

                  <div>

                    <dt className="text-slate-500 text-xs">Duração</dt>

                    <dd>{execution.durationMs != null ? `${execution.durationMs} ms` : '—'}</dd>

                  </div>

                  <div>

                    <dt className="text-slate-500 text-xs">Tokens</dt>

                    <dd className="font-semibold">{execution.totalTokens}</dd>

                  </div>

                  {execution.resumeToken && (

                    <div>

                      <dt className="text-slate-500 text-xs">Resume token</dt>

                      <dd className="font-mono text-xs break-all">{execution.resumeToken}</dd>

                    </div>

                  )}

                </dl>

                {execution.errorMessage && (

                  <p className="text-red-700 text-sm pt-3 mt-3 border-t border-slate-100">{execution.errorMessage}</p>

                )}

              </AgentPlatformPanel>



              <AgentPlatformPanel title="Input">

                <JsonTextArea value={execution.input ?? '—'} readOnly rows={6} />

              </AgentPlatformPanel>



              <AgentPlatformPanel title="Output">

                <JsonTextArea value={execution.output ?? '—'} readOnly rows={8} />

              </AgentPlatformPanel>

            </div>

          </div>

        </AgentPlatformShell>

      </AgentPlatformAdminGate>

    </AgentPlatformFeatureGate>

  );

};


